/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.overview,
            url: '/' + 'overview',
            cache: false,
            title: 'Overzicht',
            headerTitle: 'Overzicht',
            configuratorStepName: ['OverviewStep'],
            order: 6,
            operations: ['SetOVerview'],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/overview.html',
                    controller: Controllers.OverviewController.controllerId + ' as vm'
                }
            },
            showInMenu: true
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}